var exports = {
  "B_": "MessageJumpLink.module__jumpLinkButton___LVdOWF",
  "y_": "MessageJumpLink.module__part___LVdOWF",
  "Kk": "MessageJumpLink.module__icon___LVdOWF",
  "$f": "MessageJumpLink.module__guildIcon___LVdOWF",
  "yF": "MessageJumpLink.module__divider___LVdOWF",
  "UU": "MessageJumpLink.module__name___LVdOWF",
  "m0": "MessageJumpLink.module__noAccess___LVdOWF",
};

module.exports = exports;
